// The ask for notifications (FE-51): a bar in the install bar's style (design system Toast) with
// Yes and Not now. Only after the player's first finished round, never in play, never on a phone
// that can't get them (lib/push says which), once a visit at most. Only Yes opens the browser's own
// prompt, so a "no" costs us one bar and not the permission. Not now waits 14 days; after the
// browser's refusal it never comes back.
import { useEffect, useState } from 'react';
import { askLater, mayAsk, onPush, pushOffered, pushView, refreshPush, report, turnOn } from '../lib/push';
import { useUi } from '../store/ui';
import { S } from '../strings';

let askedThisVisit = false;

export function PushAsk({ hidden }: { hidden: boolean }) {
  const [view, setView] = useState(pushView);
  const [open, setOpen] = useState(false);
  useEffect(() => onPush(setView), []);

  useEffect(() => {
    // signed in since boot (a new guest, a sign-in): where this phone stands, read once on the menu
    if (!hidden && view.status === 'none' && pushOffered()) void refreshPush().catch(() => undefined);
    if (hidden || open || askedThisVisit || !mayAsk()) return;
    // a moment after the menu settles, and never on top of the install bar
    const t = setTimeout(() => {
      if (document.querySelector('.install-bar') || askedThisVisit || !mayAsk()) return;
      askedThisVisit = true;
      setOpen(true);
      report('shown');
    }, 1_200);
    return () => clearTimeout(t);
  }, [hidden, open, view.status]);

  if (!open || hidden) return null;
  const close = () => setOpen(false);
  return (
    <section className="install-bar push-ask" aria-label={S.push.ask}>
      <div className="wh-toast wh-toast--callout install-bar__toast">
        <span className="install-bar__text">{S.push.ask}</span>
        <button
          type="button"
          className="wh-btn wh-btn--carry wh-btn--sm"
          disabled={view.busy}
          onClick={() => {
            report('yes');
            close();
            turnOn()
              .then((s) => {
                if (s === 'blocked') useUi.getState().set({ notice: S.push.denied, noticeTone: 'info' });
              })
              .catch(() => useUi.getState().set({ notice: S.push.failed, noticeTone: 'info' }));
          }}
        >
          {S.push.yes}
        </button>
        <button
          type="button"
          className="wh-btn wh-btn--ghost wh-btn--sm"
          onClick={() => {
            askLater();
            close();
          }}
        >
          {S.push.later}
        </button>
      </div>
    </section>
  );
}
